import React from "react";

function Lines() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="6"
      viewBox="0 0 60 6"
    >
      <path d="M0 0H25.594V1.5H0z"></path>
      <path d="M34.406 0H60V1.5H34.406z" data-name="Rectangle 1 copy 2"></path>
      <path d="M27 0H33V1.5H27z" data-name="Rectangle 1 copy"></path>
      <rect
        width="25.594"
        height="1.5"
        x="13.5"
        y="4.5"
        data-name="Rectangle 1 copy 3"
        rx="0.5"
        ry="0.5"
      ></rect>
      <rect
        width="6"
        height="1.5"
        x="40.5"
        y="4.5"
        data-name="Rectangle 1 copy 3"
        rx="0.5"
        ry="0.5"
      ></rect>
    </svg>
  );
}

export default Lines;